/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CommandTypeConstants } from './CommandTypeConstants';
import {
    CommandTypeConstantsFromJSON,
    CommandTypeConstantsFromJSONTyped,
    CommandTypeConstantsToJSON,
} from './CommandTypeConstants';
import type { EntitySelectionConstants } from './EntitySelectionConstants';
import {
    EntitySelectionConstantsFromJSON,
    EntitySelectionConstantsFromJSONTyped,
    EntitySelectionConstantsToJSON,
} from './EntitySelectionConstants';
import type { HttpVerbConstants } from './HttpVerbConstants';
import {
    HttpVerbConstantsFromJSON,
    HttpVerbConstantsFromJSONTyped,
    HttpVerbConstantsToJSON,
} from './HttpVerbConstants';
import type { IconRef } from './IconRef';
import {
    IconRefFromJSON,
    IconRefFromJSONTyped,
    IconRefToJSON,
} from './IconRef';

/**
 * The session-wide commands, typically rendered as main navigation menu
 * @export
 * @interface Command
 */
export interface Command {
    /**
     * 
     * @type {string}
     * @memberof Command
     */
    title: string;
    /**
     * 
     * @type {IconRef}
     * @memberof Command
     */
    icon?: IconRef;
    /**
     * 
     * @type {string}
     * @memberof Command
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof Command
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof Command
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof Command
     */
    label?: string;
    /**
     * The (optional) CSS style hint
     * @type {string}
     * @memberof Command
     */
    styleHint?: string;
    /**
     * 
     * @type {CommandTypeConstants}
     * @memberof Command
     */
    commandType?: CommandTypeConstants;
    /**
     * Group of commands
     * @type {Array<Command>}
     * @memberof Command
     */
    commands: Array<Command>;
    /**
     * 
     * @type {EntitySelectionConstants}
     * @memberof Command
     */
    entitySelection?: EntitySelectionConstants;
    /**
     * To support 'lazy/async loading' of command. If set, only 'id', 'httpVerb' and 'label' are provided in addition.
     * @type {string}
     * @memberof Command
     */
    fetchUrl?: string;
    /**
     * 
     * @type {HttpVerbConstants}
     * @memberof Command
     */
    httpVerb?: HttpVerbConstants;
    /**
     * Number of required entities, only available if EntitySelection is Required/Optional.
     * @type {number}
     * @memberof Command
     */
    numberOfEntitiesRequired?: number;
}

/**
 * Check if a given object implements the Command interface.
 */
export function instanceOfCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "commands" in value;

    return isInstance;
}

export function CommandFromJSON(json: any): Command {
    return CommandFromJSONTyped(json, false);
}

export function CommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): Command {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'title': json['title'],
        'icon': !exists(json, 'icon') ? undefined : IconRefFromJSON(json['icon']),
        'id': json['id'],
        'active': !exists(json, 'active') ? undefined : json['active'],
        'url': !exists(json, 'url') ? undefined : json['url'],
        'label': !exists(json, 'label') ? undefined : json['label'],
        'styleHint': !exists(json, 'styleHint') ? undefined : json['styleHint'],
        'commandType': !exists(json, 'commandType') ? undefined : CommandTypeConstantsFromJSON(json['commandType']),
        'commands': ((json['commands'] as Array<any>).map(CommandFromJSON)),
        'entitySelection': !exists(json, 'entitySelection') ? undefined : EntitySelectionConstantsFromJSON(json['entitySelection']),
        'fetchUrl': !exists(json, 'fetchUrl') ? undefined : json['fetchUrl'],
        'httpVerb': !exists(json, 'httpVerb') ? undefined : HttpVerbConstantsFromJSON(json['httpVerb']),
        'numberOfEntitiesRequired': !exists(json, 'numberOfEntitiesRequired') ? undefined : json['numberOfEntitiesRequired'],
    };
}

export function CommandToJSON(value?: Command | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'title': value.title,
        'icon': IconRefToJSON(value.icon),
        'id': value.id,
        'active': value.active,
        'url': value.url,
        'label': value.label,
        'styleHint': value.styleHint,
        'commandType': CommandTypeConstantsToJSON(value.commandType),
        'commands': ((value.commands as Array<any>).map(CommandToJSON)),
        'entitySelection': EntitySelectionConstantsToJSON(value.entitySelection),
        'fetchUrl': value.fetchUrl,
        'httpVerb': HttpVerbConstantsToJSON(value.httpVerb),
        'numberOfEntitiesRequired': value.numberOfEntitiesRequired,
    };
}

